import PropTypes from 'prop-types';
import React, { useState } from 'react';
import './Card.scss';
function Card(_ref) {
  var {
    title,
    actions = [],
    subdued = false,
    children,
    className
  } = _ref;
  var [loadingAction, setLoadingAction] = useState(null);
  var handleAction = async (action, index) => {
    if (loadingAction !== null || !action.onAction) return;
    setLoadingAction(index);
    try {
      var result = action.onAction();
      if (result && typeof result.then === 'function') {
        await result;
      }
    } catch (error) {
      throw new Error('Action error:', error);
    } finally {
      setLoadingAction(null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: subdued ? 'card shadow subdued' : 'card shadow '
  }, (title || actions.length > 0) && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between card-header"
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: "card-title uppercase"
  }, title), actions.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-3"
  }, actions.map((action, index) => {
    var classNames = {
      primary: 'text-primary',
      critical: 'text-critical',
      interactive: 'text-interactive',
      secondary: 'text-secondary'
    };
    var isDisabled = loadingAction !== null;
    var isLoading = loadingAction === index;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "card-action"
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => {
        e.preventDefault();
        handleAction(action, index);
      },
      className: "".concat(classNames[action.variant ? action.variant : 'interactive'], " ").concat(isDisabled ? 'opacity-50 cursor-not-allowed' : ''),
      style: {
        pointerEvents: isDisabled ? 'none' : 'auto'
      }
    }, isLoading ? 'Loading...' : action.name));
  }))), children);
}
Card.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    onAction: PropTypes.func,
    variant: PropTypes.string,
    name: PropTypes.string
  })),
  children: PropTypes.node.isRequired,
  subdued: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
Card.defaultProps = {
  actions: [],
  subdued: false,
  title: ''
};
var Session = function Session(_ref2) {
  var {
    actions = [],
    title,
    children
  } = _ref2;
  var [loadingAction, setLoadingAction] = useState(null);
  var handleAction = async (action, index) => {
    if (loadingAction !== null || !action.onAction) return;
    setLoadingAction(index);
    try {
      var result = action.onAction();
      if (result && typeof result.then === 'function') {
        await result;
      }
    } catch (error) {
      throw new Error('Action error:', error);
    } finally {
      setLoadingAction(null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "card-section border-b box-border"
  }, (title || actions.length > 0) && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between card-section-header mb-4"
  }, title && /*#__PURE__*/React.createElement("h3", {
    className: "card-session-title"
  }, title), actions.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-3"
  }, actions.map((action, index) => {
    var classNames = {
      primary: 'text-primary',
      critical: 'text-critical',
      interactive: 'text-interactive',
      secondary: 'text-secondary',
      success: 'text-[#4caf50]'
    };
    var isDisabled = loadingAction !== null;
    var isLoading = loadingAction === index;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "card-action"
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => {
        e.preventDefault();
        handleAction(action, index);
      },
      className: "".concat(classNames[action.variant ? action.variant : 'interactive'], " ").concat(isDisabled ? 'opacity-50 cursor-not-allowed' : ''),
      style: {
        pointerEvents: isDisabled ? 'none' : 'auto'
      }
    }, isLoading ? 'Loading...' : action.name));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card-session-content pt-lg"
  }, children));
};
Session.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    onAction: PropTypes.func,
    variant: PropTypes.string,
    name: PropTypes.string
  })),
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
Session.defaultProps = {
  actions: [],
  title: '',
  children: null
};
Card.Session = Session;
export { Card };